import { findTopic, flattenTree, searchTopics } from "./schema.js";
import { BUYER_META, BUYER_TREE } from "./buyer.js";
import { SELLER_META, SELLER_TREE } from "./seller.js";
import { AGENT_META, AGENT_TREE } from "./agent.js";
import { BROKER_META, BROKER_TREE } from "./broker.js";

const PACKS = {
  buyer: { meta: BUYER_META, tree: BUYER_TREE },
  seller: { meta: SELLER_META, tree: SELLER_TREE },
  agent: { meta: AGENT_META, tree: AGENT_TREE },
  broker: { meta: BROKER_META, tree: BROKER_TREE },
};

export const MANUAL_ROLES = ["buyer", "seller", "agent", "broker"];

export function getManual(role) {
  return PACKS[role] || null;
}

export function getTopic(role, slug) {
  const pack = getManual(role);
  return pack ? findTopic(pack.tree, slug) : null;
}

export function relatedTopics(role, slugs = []) {
  return slugs.map((slug) => getTopic(role, slug)).filter(Boolean);
}

export function allTopics(role) {
  const pack = getManual(role);
  return pack ? flattenTree(pack.tree) : [];
}

export { searchTopics, flattenTree, findTopic };
